import React from "react";

const SupportTickets = () => {
  const iframeUrl = `${process.env.REACT_APP_SOLUTION_CENTER_BASE_URL}/?token=${window.localStorage.access_token}`;
  return (
    <div className="app-dashboard">
      {
        <iframe
          src={iframeUrl}
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      }
    </div>
  );
};

export default SupportTickets;
